export const todayIsoDate = (now: Date = new Date()) => {
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
};

export const isBeforeToday = (isoDate: string, today: string = todayIsoDate()) => !!isoDate && isoDate < today;

export const lastActiveDateLabel = (isoDate: string) => {
  const [year, month, day] = isoDate.split("-");
  return `until ${day}.${month}.${year}`;
};
